import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store"
import {
	post
} from "@/service/http"
Vue.use(VueRouter)
const routes = [{
		path: "/",
		name: "首页",
		component: () => import("../views/main.vue")
		// component: () => import("../views/ticketPage/index.vue")
	},
	{
		path: "/my",
		meta: {
			auth: true,
			name: "我的",
		},
		component: () => import("../views/userCenterPage.vue")
	},
	{
		path: "/touristIndex",
		meta: {
			auth: true,
			name: "景点门票",
		},
		component: () => import("../views/ticketPage/index.vue")
	},
	{
		path: "/classList",
		meta: {
			auth: true,
			name: "景点门票",
		},
		component: () => import("../views/ticketPage/classList.vue")
	},
	{
		path: "/search",

		meta: {
			auth: true,
			name: "景点门票",
		},
		component: () => import("../views/ticketPage/classify.vue")
	},
	{
		path: "/detail",
		meta: {
			auth: true,
			name: "景点门票详情",
		},
		component: () => import("../views/ticketPage/detail.vue")
	},
	{
		path: "/choice",
		meta: {
			auth: true,
			name: "选择套餐日期人群",
		},
		component: () => import("../views/ticketPage/choice.vue")
	},
	{
		path: "/order",
		meta: {
			auth: true,
			name: "提交订单",
		},
		component: () => import("../views/ticketPage/submitOrders.vue")
	},
	{
		path: "/traveler",
		meta: {
			auth: true,
			name: "出行人信息",
		},
		component: () => import("../views/other/traveler.vue")
	},
	{
		path: "/travelList",
		meta: {
			auth: true,
			name: "出行人列表",
		},
		component: () => import("../views/other/travelList.vue")
	},
	{
		path: "/orderList",
		meta: {
			auth: true,
			name: "订单列表",
		},
		component: () => import("../views/order/orderList.vue")
	},
	{
		path: "/groupOrder",
		meta: {
			auth: true,
			name: "订单列表",
		},
		component: () => import("../views/order/groupOrder.vue")
	},
	{
		path: "/refundList",
		meta: {
			auth: true,
			name: "退款列表",
		},
		component: () => import("../views/order/refundList.vue")
	},
	{
		path: "/refundDetail",
		meta: {
			auth: true,
			name: "退款详情",
		},
		component: () => import("../views/order/refundDetail.vue")
	},
	{
		path: "/orderDetail",
		meta: {
			auth: true,
			name: "订单详情",
		},
		component: () => import("../views/order/orderDetail.vue")
	},
	{
		path: "/myCoupons",
		meta: {
			auth: true,
			name: "优惠券",
		},
		component: () => import("../views/other/myCoupons.vue")
	},
	{
		path: "/voucherList",
		meta: {
			auth: true,
			name: "兑换券",
		},
		component: () => import("../views/other/voucherList.vue")
	},
	{
		path: "/packageTour",
		meta: {
			auth: true,
			name: "跟团游",
		},
		component: () => import("../views/packageTour/index.vue")
	},
	{
		path: "/packageSearch",
		meta: {
			auth: true,
			name: "搜索",
		},
		component: () => import("../views/packageTour/search.vue")
	},
	{
		path: "/more",
		meta: {
			auth: true,
			name: "",
		},
		component: () => import("../views/packageTour/moreLocations.vue")
	},
	{
		path: "/origin",
		meta: {
			auth: true,
			name: "",
		},
		component: () => import("../views/packageTour/moreOrigin.vue")
	},
	{
		path: "/swimIndex",
		meta: {
			auth: true,
			name: "火车专列",
		},
		component: () => import("../views/swimPage/index.vue")
	},
	{
		path: "/swimDetail",
		meta: {
			auth: true,
			name: "火车专列详情",
		},
		component: () => import("../views/swimPage/detail.vue")
	},
	{
		path: "/person",
		meta: {
			auth: true,
			name: "火车列表出行人添加",
		},
		component: () => import("../views/swimPage/person.vue")
	},
	{
		path: "/groupPackage",
		meta: {
			auth: true,
			name: "火车专列团期",
		},
		component: () => import("../views/swimPage/groupPackage.vue")
	},
	{
		path: "/contact",
		meta: {
			auth: true,
			name: "添加联系人",
		},
		component: () => import("../views/swimPage/contact.vue")
	},
	{
		path: "/swimorder",
		meta: {
			auth: true,
			name: "订单详情",
		},
		component: () => import("../views/swimPage/orderDetail.vue")
	},
	{
		path: "/customSwim",
		meta: {
			auth: true,
			name: "东北定制游",
		},
		component: () => import("../views/customSwim/index.vue")
	},
	{
		path: "/young",
		meta: {
			auth: true,
			name: "星球少年",
		},
		component: () => import("../views/young/index.vue")
	},
	{
		path: "/youngDetail",
		meta: {
			auth: true,
			name: "星球少年详情",
		},
		component: () => import("../views/young/detail.vue")
	},
	{
		path: "/cruise",
		meta: {
			auth: true,
			name: "邮轮游",
		},
		component: () => import("../views/cruise/index.vue")
	},
	{
		path: "/cruiseDetail",
		meta: {
			auth: true,
			name: "邮轮游详情",
		},
		component: () => import("../views/cruise/detail.vue")
	},
	{
		path: "/cruiseChoice",
		meta: {
			auth: true,
			name: "邮轮游选择信息",
		},
		component: () => import("../views/cruise/choice.vue")
	},
	{
		path: "/cruiseOrder",
		meta: {
			auth: true,
			name: "填写订单",
		},
		component: () => import("../views/cruise/cruiseOrder.vue")
	},
	{
		path: "/editInfo",
		meta: {
			auth: true,
			name: "编辑信息",
		},
		component: () => import("../views/cruise/editInfo.vue")
	},
	{
		path: "/cruiseOrderList",
		meta: {
			auth: true,
			name: "邮轮游订单",
		},
		component: () => import("../views/cruise/orderList.vue")
	},
	{
		path: "/cruiseOrderDetail",
		meta: {
			auth: true,
			name: "订单详情",
		},
		component: () => import("../views/cruise/cruiseOrderDetail.vue")
	},
	{
		path: "/indexAll",
		meta: {
			auth: true,
			name: "全部类目",
		},
		component: () => import("../views/other/indexAll.vue")
	},
	{
		path: "/integral",
		meta: {
			auth: true,
			name: "我的积分",
		},
		component: () => import("../views/integral/integral.vue")
	},
	{
		path: "/exchange",
		meta: {
			auth: true,
			name: "兑换记录",
		},
		component: () => import("../views/integral/exchange.vue")
	},
	{
		path: "/shop",
		meta: {
			auth: true,
			name: "积分商城",
		},
		component: () => import("../views/integral/shop.vue")
	},
	{
		path: "/shopDetail",
		meta: {
			auth: true,
			name: "积分商城",
		},
		component: () => import("../views/integral/shopDetail.vue")
	},
	{
		path: "/shopOrder",
		meta: {
			auth: true,
			name: "积分商城",
		},
		component: () => import("../views/integral/shopOrder.vue")
	},
	{
		path: "/shopTraveler",
		meta: {
			auth: true,
			name: "新增收货地址",
		},
		component: () => import("../views/integral/shopTraveler.vue")
	},
	{
		path: "/visa",
		meta: {
			auth: true,
			name: "签证",
		},
		component: () => import("../views/visa/index.vue")
	},
	{
		path: "/indexBar",
		meta: {
			auth: true,
			name: "签证",
		},
		component: () => import("../views/visa/indexBar.vue")
	},
	{
		path: "/passhot",
		meta: {
			auth: true,
			name: "签证",
		},
		component: () => import("../views/visa/passhot.vue")
	},
	{
		path: "/visaserch",
		meta: {
			auth: true,
			name: "签证",
		},
		component: () => import("../views/visa/search.vue")
	},
	{
		path: "/visadetail",
		meta: {
			auth: true,
			name: "签证详情",
		},
		component: () => import("../views/visa/detail.vue")
	},
	{
		path: "/comments",
		meta: {
			auth: true,
			name: "游客点评",
		},
		component: () => import("../views/visa/comments.vue")
	},
	{
		path: "/visachoice",
		meta: {
			auth: true,
			name: "选择套餐日期人群",
		},
		component: () => import("../views/visa/choice.vue")
	},
	{
		path: "/visaorder",
		meta: {
			auth: true,
			name: "填写信息",
		},
		component: () => import("../views/visa/order.vue")
	},
	{
		path: "/visatraveler",
		meta: {
			auth: true,
			name: "添加常用联系人",
		},
		component: () => import("../views/visa/traveler.vue")
	},
	{
		path: "/orderStatus",
		meta: {
			auth: true,
			name: "订单详情",
		},
		component: () => import("../views/visa/orderStatus.vue")
	},
	{
		path: "/call",
		meta: {
			auth: true,
			name: "完善出行人信息",
		},
		component: () => import("../views/visa/call.vue")
	},
	{
		path: "/evaluate",
		meta: {
			auth: true,
			name: "点评订单",
		},
		component: () => import("../views/visa/evaluate.vue")
	}
]

const router = new VueRouter({
	// mode: "history",
	routes
})
// router.beforeEach((to, from, next) => {
// console.log(to.query.accessLink)
// https://open.sweetour.com:9000/LST/Login?accessLink=111&addrCode=111
// const userInfo = store.getters["account/userInfo"]
// let {
// 	meta: {
// 		auth
// 	}
// } = to
// if (auth) {
// 	// console.log(userInfo)
// 	if (userInfo) {
// 		next()
// 	} else {
// 		// next("/login")
// 		post(
// 			"https://mer.sweetour.com:9000/api/services/app/TeamAll/GetToken?organizationId=2", {}
// 		).then(res => {
// 			console.log(res)
// 			localStorage.setItem("userInfo", 117643)
// 			next()
// 		})
// 	}
// } else {
// 	next()
// }
// next()
// })
//解决守卫报错，修改报错信息
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) {
		return originalPush.call(this, location, onResolve, onReject)
	}
	return originalPush.call(this, location).catch(err => err)
}

router.afterEach((to, from) => {
	window.scrollTo(0, 0)
	document.querySelector("body").setAttribute("style", "background-color:#fff")
})

export default router